import React from 'react';
import './InternPage.css';
import internImg from '../images/InternPage_header.png';
import benefitsImg from '../images/InternPage_benefits.jpg';
import InternPage_Strip from '../images/InternPage_Strip.png';
import InternPage_Icon_1 from '../images/InternPage_Icon_1.png';
import InternPage_Icon_2 from '../images/InternPage_Icon_2.png';
import InternPage_Icon_3 from '../images/InternPage_Icon_3.png';
import InternPage_Icon_4 from '../images/InternPage_Icon_4.png';
import image1 from '../images/InternPage_card1.jpg';
import image2 from '../images/InternPage_card2.jpg';
import image3 from '../images/InternPage_card3.jpg';

function InternPage() {
  return (
    <>
      {/* hero section */}
      <section className="intern-hero">
        <img src={internImg} alt="Internship Banner" className="intern-bg" />
        <div className="intern-text-block">
          <p className="intern-subtitle">JOIN OUR TEAM</p>
          <h1 className="intern-title">Apply to be an Intern</h1>
          <p className="intern-description">
            We are currently recruiting high school and college students for an <strong>EIGHTH</strong> cohort. While no previous experience is necessary,
            all we ask is that applicants are passionate about building a future of love and tolerance through food.
          </p>
          <p className="intern-scroll">Learn more below</p>
        </div>
      </section>

      {/* internship benefits section */}
      <section className="benefits-section">
        <div className="benefits-container">
          <h2 className="benefits-header">Internship Benefits</h2>
          <div className="benefits-content">
            <img src={benefitsImg} alt="Interns Working" className="benefits-image" />

            <div className="benefits-texts">
              <img src={InternPage_Strip} alt="Line" className="benefits-strip" />

              <div className="benefit-pair">
                <img src={InternPage_Icon_1} alt="Mentorship Icon" className="benefit-icon" />
                <div className="benefit-description">
                  <strong>Mentorship:</strong> Be paired with a mentor, offering personalized guidance and support from someone with experience in the field.
                </div>
              </div>

              <div className="benefit-pair">
                <img src={InternPage_Icon_2} alt="Problem Solving Icon" className="benefit-icon" />
                <div className="benefit-description">
                  <strong>Real-World Problem Solving:</strong> Work on projects that address real-world issues, giving practical experience and the chance to make a tangible impact.
                </div>
              </div>

              <div className="benefit-pair">
                <img src={InternPage_Icon_3} alt="Networking Icon" className="benefit-icon" />
                <div className="benefit-description">
                  <strong>Networking Opportunities:</strong> Gain insights and connections through weekly workshops with successful women founders and entrepreneurs.
                </div>
              </div>

              <div className="benefit-pair">
                <img src={InternPage_Icon_4} alt="Growth Icon" className="benefit-icon" />
                <div className="benefit-description">
                  <strong>Personal Growth:</strong> The combination of mentorship, skill-building, and real-world experience promotes significant personal and professional growth.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* internship details section */}
      <section className="details-section">
        <h2 className="details-header">Internship Details</h2>
        <div className="details-scroll-wrapper">
          <button
            className="details-scroll-btn left"
            onClick={() => {
              document.querySelector('.details-carousel').scrollBy({ left: -250, behavior: 'smooth' });
            }}
          >
            &#8249;
          </button>

          <div className="details-carousel">
            <div className="details-card">
              <img src={image1} alt="Culinary" className="details-img" />
              <div className="details-text">
                <strong>Culinary</strong>
                <p>
                  Facilitate cooking workshops and create travel itinerary/virtual tours, trivia games, and cultural presentations for workshops.
                </p>
              </div>
            </div>

            <div className="details-card">
              <img src={image2} alt="Outreach" className="details-img" />
              <div className="details-text">
                <strong>Outreach & Communications</strong>
                <p>
                  Promote Cultured Kids Cuisine via deliverables to cultivate partnerships and gain more passionate volunteers.
                </p>
              </div>
            </div>

            <div className="details-card">
              <img src={image3} alt="Digital Marketing" className="details-img" />
              <div className="details-text">
                <strong>Digital Marketing & Engagement</strong>
                <p>
                  Create TikTok videos aligned with our mission and popular trends, draft posts, write captions, and engage with users on social media.
                </p>
              </div>
            </div>
          </div>

          <button
            className="details-scroll-btn right"
            onClick={() => {
              document.querySelector('.details-carousel').scrollBy({ left: 250, behavior: 'smooth' });
            }}
          >
            &#8250;
          </button>
        </div>

        <div className="details-button-wrapper">
          <button
            type="button"
            className="details-apply"
            onClick={() => {
              window.open('https://forms.gle/onZ3kyRtUMw5keTF9', '_blank', 'noopener,noreferrer');
            }}
          >
            Apply Now
          </button>
        </div>
      </section>
    </>
  );
}

export default InternPage;
